import { Injectable, UseFilters } from '@nestjs/common';
import { Repository } from 'typeorm';
import { Designation } from './designation.entity';
import { DesignationDTO } from './dto/designation.dto';
import { InjectRepository } from '@nestjs/typeorm';
import { DesignationAdapter } from './dto/designation.adapter';
import { DesignationResponseModel, AllDesignationResponseModel } from '@gtpl/shared-models/hrms';
import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { DesignationRequest } from './dto/designation.request';
import { LogsService } from '@gtpl/shared-services/user-logs';
import { LogsDto } from 'libs/shared-models/user-logs/src/lib/Logs/logs.dto';

@Injectable()
export class DesignationService {

    constructor(
      private logService:LogsService,
        @InjectRepository(Designation)
        private designationRepository: Repository<Designation>,
        private designationAdapter: DesignationAdapter,
    ) { }

    async getDesignationWithoutRelations(designation: string): Promise<Designation> {
        const designationResponse = await this.designationRepository.findOne({
            where: { designation: designation },
        });
        if (designationResponse) {
            return designationResponse;
        } else {
            return null;
        }
    }

    async createDesignation(designationDTO: DesignationDTO, isUpdate: boolean): Promise<DesignationResponseModel> {
        try {
            if (!isUpdate) {
                const designationEntity = await this.getDesignationWithoutRelations(designationDTO.designation);
                if (designationEntity) {
                    throw new ErrorResponse(11104, 'designation already exists');
                }
            } else {
                const designationEntity = await this.getDesignationWithoutRelations(designationDTO.designation);
                if (designationEntity) {
                    if (designationEntity.designationId != designationDTO.designationId) {
                        throw new ErrorResponse(11104, 'designation already exists')
                    }
                }
            }
            const convertedEntity: Designation = this.designationAdapter.convertDtoToEntity(designationDTO, isUpdate);
            const savedEntity: Designation = await this.designationRepository.save(convertedEntity);
            const savedDto: DesignationDTO = this.designationAdapter.convertEntityToDto(savedEntity);
            if (savedDto) {
                const response = new DesignationResponseModel(true, 1, isUpdate ? 'Designation Updated Successfully' : 'Designation Created Successfully');
                const name=isUpdate?'updated':'created'
            
                const newLogDto = new LogsDto(1,name, 'Designation', savedDto.designationId, true, '',savedDto.createdUser)
                let res = await this.logService.createLog(newLogDto);
                console.log(res);
                return response;
            } else {
                throw new ErrorResponse(11106, 'Designation saved but issue while transforming it into DTO');
            }
        } catch (error) {
            throw error;
        }
    }

    async getAllDesignation(): Promise<AllDesignationResponseModel> {
        try {
            const designationDtos: DesignationDTO[] = [];
            const designationEntities: Designation[] = await this.designationRepository.find({ order: { designation: 'ASC' } });
            if (designationEntities) {
                designationEntities.forEach(Entity => {
                    const convertedDto: Designation = this.designationAdapter.convertEntityToDto(Entity);
                    designationDtos.push(convertedDto);
                });
                const response = new AllDesignationResponseModel(true, 1, 'Designation Retrieved Successfully', designationDtos);
                
            const newLogDto = new LogsDto(1,'view', 'Designation', 0, true, '','')
            let res = await this.logService.createLog(newLogDto);
            console.log(res);
                return response;
            } else {
                throw new ErrorResponse(99998, 'Data Not Found');
            }
        } catch (err) {
            throw err;
        }
    }

    async getAllActiveDesignation(): Promise<AllDesignationResponseModel> {
        try {
            const designationDtos: DesignationDTO[] = [];
            const designationEntities: Designation[] = await this.designationRepository.find({ order: { designation: 'ASC' }, where: { isActive: true }, });
            if (designationEntities) {
                designationEntities.forEach(Entity => {
                    const convertedEntity: Designation = this.designationAdapter.convertEntityToDto(Entity);
                    designationDtos.push(convertedEntity);
                });
                const response = new AllDesignationResponseModel(true, 11108, 'Active Loan Categories Retrieved Successfully', designationDtos);
                return response;
            } else {
                throw new ErrorResponse(99998, 'Data Not Found');
            }
        } catch (err) {
            throw err;
        }
    }

    async getDesignationById(designationId: number): Promise<Designation> {
        const response = await this.designationRepository.findOne({
            where: { designationId: designationId },
        });
        if (response) {
            return response;
        } else {
            return null;
        }
    }

    async activateOrDeactivateDesignation(designationReq: DesignationRequest): Promise<DesignationResponseModel> {
        try {
            const designationExists = await this.getDesignationById(designationReq.designationId);
            if (designationExists) {
                if (designationReq.versionFlag != designationExists.versionFlag) {
                    throw new ErrorResponse(10113, 'Someone updated the current designation information. Refresh and try again');
                } else {
                    const designationStatus = await this.designationRepository.update(
                        { designationId: designationReq.designationId },
                        { isActive: designationReq.isActive, updatedUser: designationReq.updatedUser }
                    );
                    if (designationExists.isActive) {
                        if (designationStatus.affected) {
                            const designationResponse: DesignationResponseModel = new DesignationResponseModel(true, 10115, 'designation is de-activated successfully');
                            return designationResponse;
                        } else {
                            throw new ErrorResponse(10111, ' designation is already de-activated');
                        }
                    } else {
                        if (designationStatus.affected) {
                            const designationResponse: DesignationResponseModel = new DesignationResponseModel(true, 10114, 'designation is activated successfully');
                            return designationResponse;
                        } else {
                            throw new ErrorResponse(10112, 'designation is already activated');
                        }
                    }
                }
            } else {
                throw new ErrorResponse(99998, 'No Records Found');
            }
        } catch (err) {
            throw err;
        }
    }
}
